<template>
  <AppLoader v-if="!shoppingCartDataLoaded" />
  <div v-if="shoppingCartDataLoaded">
    <div class="shopping-cart__wrapper animate__animated animate__fadeIn">
      <div class="shopping-cart__empty" v-if="!shoppingCartData || !shoppingCartData.cartItems.length">
        <HeadlineComponent :pageTitle="'Dein Warenkorb'" />
        <div class="shopping-cart__empty-content">
          <h2>Es liegen keine Lose in deinem Warenkorb</h2>
          <p class="shopping-cart__empty-text">Dein Warenkorb ist zurzeit leer. Wähle ein oder mehrere Lose aus. Direkt nach der Abbuchung von deinem Konto nehmen deine Lose an der nächsten Ziehung teil.</p>
        </div>
        <div class="shopping-cart__empty-content">
          <div class="grid" v-if="isLargeScreen">
            <div class="shopping-cart__empty-content__column">
              <img src="../assets/images/mgl.jpg" alt="">
              <a aria-label="Glücks-Los bestellen" href="/lotterie/mein-gluecks-los" class="shopping-cart__link-button">Glücks-Los</a>
            </div>
            <div class="shopping-cart__empty-content__column">
              <img src="../assets/images/jl.jpg" alt="">
              <a aria-label="Jahreslos bestellen" href="/lotterie/jahreslos" class="shopping-cart__link-button">Jahreslos</a>
            </div>
            <div class="shopping-cart__empty-content__column">
              <img src="../assets/images/fsl.jpg" alt="">
              <a aria-label="5 Sterne-Los bestellen" href="/lotterie/5-sterne-los" class="shopping-cart__link-button">5 Sterne-Los</a>
            </div>
          </div>
          <div class="slider" v-else>
            <ImageSlider />
          </div>
        </div>
      </div>
      <div class="shopping-cart__content" v-if="shoppingCartData.cartItems.length">
        <HeadlineComponent :pageTitle="'Dein Warenkorb'" />
        <div class="shopping-cart__grid-layout">
          <ShoppingCartItemsComponent :items="shoppingCartData.cartItems" @update-cart="updateCart" @remove-item="removeItem" @show-detail="showDetail" />
          <div class="shopping-cart__aside" ref="summaryBox">
            <ShoppingCartActionCode :disableCouponCode="shoppingCartData.disableCouponCodeInput" :cartData="shoppingCartData"  :getCartData="getShoppingCartData" />
            <ShoppingCartSum :pricePartial="shoppingCartData.pricePartial" :pricePerMonth="shoppingCartData.pricePerMonth" :pricePerYear="shoppingCartData.pricePerYear" :priceOnce="shoppingCartData.priceOnce" />
          </div>
          <!-- <StickyFooter /> -->
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { ref, onMounted, onUnmounted } from 'vue';
import shoppingCartService from '@/services/shoppingCartService.js';
import HeadlineComponent from './HeadlineComponent.vue';
import ShoppingCartItemsComponent from './ShoppingCartItemsComponent.vue';
import ShoppingCartActionCode from './ShoppingCartActionCode.vue';
import ShoppingCartSum from './ShoppingCartSum.vue';
import ImageSlider from './ImageSlider.vue';
// import StickyFooter from './StickyFooter.vue';
import AppLoader from './AppLoader.vue';

export default {
  components: {
    HeadlineComponent,
    ShoppingCartItemsComponent,
    ShoppingCartActionCode,
    ShoppingCartSum,
    ImageSlider,
    // StickyFooter,
    AppLoader
  },
  setup() {
    const shoppingCartData = ref({});
    const shoppingCartDataLoaded = ref(false);
    const showItemDetail = ref(false);
    const selectedItem = ref(null);
    const displayedDetails = {};
    const isLargeScreen = ref(window.matchMedia('(min-width: 768px)').matches);

    const checkScreenSize = () => {
      isLargeScreen.value = window.matchMedia('(min-width: 768px)').matches;
    };

    const showDetail = (item) => {
      selectedItem.value = { ...item };
      showItemDetail.value = true;
    };

    const getShoppingCartData = async () => {

      const response = await shoppingCartService.getShoppingCartData();
      if (response && response.status && response.status.code === 'OK') {
        shoppingCartData.value = response.data ?? { cartItems: [] };
        shoppingCartDataLoaded.value = true;
      } else {
        console.error('Error while fetching shopping cart data:', response ? response.status : 'Unknown Error');
        shoppingCartData.value = { cartItems: [] };
        shoppingCartDataLoaded.value = true;
      }
    };

    function toggleDetail(item) {
      if (displayedDetails[item.position]) {
        displayedDetails[item.position] = false;
      } else {
        displayedDetails[item.position] = true;
      }
    }

    onMounted(() => {
      getShoppingCartData();
      window.addEventListener('resize', checkScreenSize);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', checkScreenSize);
    });

    // Return statement
    return {
      isLargeScreen,
      shoppingCartData,
      shoppingCartDataLoaded,
      showItemDetail,
      selectedItem,
      showDetail,
      displayedDetails,
      toggleDetail,
      getShoppingCartData, // Add this to make it accessible in the template
    };
  },
  methods: {
    removeItem(orderPositionId) {
      this.shoppingCartData.cartItems = this.shoppingCartData.cartItems.filter(item => item.position !== orderPositionId);

      if (typeof window.remainingOrders === 'function') {
        window.remainingOrders(this.shoppingCartData.cartItems.length);
      } else {
        console.log('remainingOrders is not a function');
      }
    },
    updateCart() {
      this.getShoppingCartData();
    },
  },
};
</script>

<style lang="scss" scoped>
.shopping-cart__wrapper:has(.shopping-cart__empty) {
  background: linear-gradient(to bottom, #eeeeee 70%, white 30%);
}

.shopping-cart {
  &__link-button {
    color: var(--color-red);
    border: 2px solid var(--color-red);
    background-color: var(--color-white);
    max-width: 110px;
    padding: 10px 18px;
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
    text-decoration: none;
    box-sizing: content-box;
    font-family: "Aktion Mensch Bold";
    transition: border-color 0.3s, color 0.3s, background-color 0.3s;

    &:hover {
      color: var(--color-white);
      border-color: var(--color-red);
      background-color: var(--color-red);
    }

    @media (max-width: 640px) {
      max-width: 100%;
    }
  }
  &__empty-content {
    .grid {
      margin-top: 24px;
      display: flex;
      gap: 32px;
      flex-direction: row;

      img {
        margin: 0;
      }
    }

    .slider {
      margin-top: 24px;
    }

    &__column {
      display: flex;
      flex-direction: column;
      gap: 23px;
    }
  }

  &__grid-layout {
    display: grid;
    grid-template-columns: 1fr;
    grid-gap: 32px;

    @media (min-width: 1380px) {
      grid-template-columns: 2fr 1fr;
    }

    @media (max-width: 767px) {
      grid-gap: 24px;
    }
  }
  &__empty {
    padding: 32px 16px;
    max-width: 1248px;
    overflow: hidden;
    margin: 0 auto;
    box-sizing: border-box;
    font-family: "Aktion Mensch Regular";
    color: var(--color-text);
    font-size: 14px;

    img {
      margin: 1.5rem;
      width: 100%;
    }

    h1 {
      line-height: 38px;
      font-size: 30px;
      font-family: "Aktion Mensch Bold";
      margin-bottom: 40px;

      @media (max-width: 767px) {
        line-height: 29px;
        font-size: 23px;
      }
    }

    h2 {
      line-height: 29px;
      font-size: 23px;
      font-family: "Aktion Mensch Bold";
      margin-bottom: 12px;
      color: var(--color-red);

      @media (max-width: 767px) {
        line-height: 25px;
        font-size: 20px;
      }
    }

    p {
      margin: 0;
      padding: 0;
      line-height: 21px;
      font-size: 14px;
      max-width: 665px;
    }
  }

  &__content {
    box-sizing: border-box;
    margin: 0 auto;
    max-width: 1248px;
    padding: 32px 16px 32px 16px;

    @media (max-width: 1379px) {
      padding-bottom: 0;
    }

    @media (max-width: 767px) {
      padding: 24px 16px 0 16px;
    }
  }

  &__aside {
    position: relative;
    box-sizing: border-box;
    padding: 0;

    @media (min-width: 1248px) and (max-width: 1379px) {
      margin: 0 calc(((100vw - 1278px) / 2 + 32px) * -1);

      .shopping-cart__action-code {
        padding: 0 calc((100vw - 1278px) / 2 + 16px);
      }

      .shopping-cart-sum {
        padding-left: calc((100vw - 1278px) / 2 + 48px);
        padding-right: calc((100vw - 1278px) / 2 + 48px);
      }
    }

    @media (max-width: 1247px) {
      margin: 0 -15px;

      .shopping-cart__action-code {
        padding: 0;
      }

      .shopping-cart-sum {
        padding-left: 32px;
        padding-right: 32px;
      }
    }

    @media (max-width: 767px) {
      margin: 0 -16px;

      .shopping-cart__action-code {
        padding: 0;
      }

      .shopping-cart-sum {
        padding-left: 32px;
        padding-right: 32px;
      }
    }
  }
}
</style>
